var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_vm.visible ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" " + _vm._s(_vm.edit ? "Editar" : "Cadastrar") + " Ano Letivo ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "Ano Letivo*",
      "maxlength": "4",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, function (v) {
        return _vm.$max(v, 4);
      }, function (v) {
        return _vm.$min(v, 4);
      }]
    },
    model: {
      value: _vm.content.ano,
      callback: function ($$v) {
        _vm.$set(_vm.content, "ano", $$v);
      },
      expression: "content.ano"
    }
  })], 1), _c('sca-date-picker', {
    attrs: {
      "cols": 12,
      "label": "Data de Início*",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$required(v);
      }, _vm.dataInicioMenorQueFim],
      "allowedDates": _vm.anoAtualOuMaior
    },
    model: {
      value: _vm.content.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataInicio", $$v);
      },
      expression: "content.dataInicio"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 12,
      "label": "Data de Término*",
      "outlined": "",
      "dense": "",
      "allowedDates": _vm.anoAtualOuMaior,
      "rules": [function (v) {
        return _vm.$required(v);
      }, _vm.dataInicioMenorQueFim]
    },
    model: {
      value: _vm.content.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.content, "dataFim", $$v);
      },
      expression: "content.dataFim"
    }
  })], 1)], 1), _c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios")])], 1)], 1), _c('sca-buttons', {
    attrs: {
      "actionText": _vm.edit ? 'Editar' : 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }